import React from 'react';
import classNames from 'classnames';

import './index.scss';

export type MarketplacePropTypes = {
  title: string;
  pinToBottom: boolean;
  image: string;
  elementText?: string;
  element?: string;
};

const Marketplace = ({
  title,
  element,
  elementText,
  image,
}: MarketplacePropTypes) => (
  <div className='marketplace'>
    <div
      className='marketplace-image'
      style={{ backgroundImage: `url(${image})` }}
    />
    {elementText && (
      <div
        className={classNames(
          'marketplace-element',
          `marketplace-element-${element}`,
        )}
      >
        {elementText}
      </div>
    )}
    <div className='marketplace-title'>{title}</div>
  </div>
);

export default Marketplace;
